import React, { useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route, useLocation, Outlet } from 'react-router-dom'
import { I18nextProvider, useTranslation } from 'react-i18next'
import i18n from './i18n'
import Navbar from './components/Navbar'
import Home from './pages/Home'
import PrivacyPolicy from './pages/PrivacyPolicy'
import TermsOfService from './pages/TermsOfService'
import CourseRegistration from './pages/CourseRegistration'
import MediaBuying from './pages/MediaBuying'
import QRLanding from './pages/QRLanding'
import BlogList from './pages/BlogList'
import BlogPost from './pages/BlogPost'
import B2BSales from './pages/B2BSales'
import Packages from './pages/Packages'
import PayrollXPackage from './pages/PayrollXPackage'
import NotFound from './pages/NotFound'
import Footer from './components/Footer'
import { setupRouteTracking } from './utils/metaCapi'

/** Fires Meta CAPI PageView on every route change + scrolls to top */
function RouteTracker() {
  const location = useLocation();
  useEffect(() => {
    setupRouteTracking();
    window.scrollTo(0, 0);
  }, [location.pathname]);
  return null;
}

function AppLayout() {
  const location = useLocation();
  const noChrome = location.pathname.startsWith('/b2b-sales');
  const { i18n } = useTranslation();
  const isRtl = i18n.language === 'ar';

  if (noChrome) {
    return <Outlet />;
  }

  return (
      <div className="min-h-screen bg-brand-dark overflow-x-hidden" dir={isRtl ? 'rtl' : 'ltr'}>
        <div className="keep-ltr">
          <Navbar />
        </div>
        <main>
          <Outlet />
        </main>
        <div className="keep-ltr">
          <Footer />
        </div>
      </div>
  );
}

function App() {
  const host = window.location.host.toLowerCase();
  const isCourseSubdomain = host.startsWith('course.') || host === 'course.localhost:5173';
  const isMediaBuyingSubdomain = host.startsWith('media-buying.') || host === 'media-buying.localhost:5173';
  const isQRLandingSubdomain = host.startsWith('qr.') || host === 'qr.localhost:5173';

  if (isQRLandingSubdomain) {
    return (
      <I18nextProvider i18n={i18n}>
      <Router>
        <RouteTracker />
        <div className="min-h-screen bg-brand-dark overflow-x-hidden">
          <Routes>
            <Route path="/*" element={<QRLanding />} />
          </Routes>
        </div>
      </Router>
      </I18nextProvider>
    );
  }

  if (isCourseSubdomain) {
    return (
      <I18nextProvider i18n={i18n}>
      <Router>
        <RouteTracker />
        <div className="min-h-screen bg-brand-dark overflow-x-hidden">
          <Routes>
            <Route path="/*" element={<CourseRegistration />} />
          </Routes>
        </div>
      </Router>
      </I18nextProvider>
    );
  }

  if (isMediaBuyingSubdomain) {
    return (
      <I18nextProvider i18n={i18n}>
      <Router>
        <RouteTracker />
        <div className="min-h-screen bg-brand-dark overflow-x-hidden">
          <Routes>
            <Route path="/*" element={<MediaBuying />} />
          </Routes>
        </div>
      </Router>
      </I18nextProvider>
    );
  }

  return (
    <I18nextProvider i18n={i18n}>
    <Router>
      <RouteTracker />
      <Routes>
        <Route element={<AppLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/qr" element={<QRLanding />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/blog" element={<BlogList />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/b2b-sales" element={<B2BSales />} />
          <Route path="/packages" element={<Packages />} />
          <Route path="/packages/payrollx" element={<PayrollXPackage />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </Router>
    </I18nextProvider>
  )
}

export default App
